export const IMAGES = {
  hero: "/images/stir/hero.jpg",
  about: "/images/stir/white-bar.jpg",
  cta: "/images/stir/cocktails-evening.jpg",
};

export const NAV_LINKS = [
  { id: "home", hash: "#top" },
  { id: "about", hash: "#about" },
  { id: "services", hash: "#services" },
  { id: "packages", hash: "#packages" },
  { id: "faq", hash: "#faq" },
  { id: "contact", hash: "#contact" },
];

export const GALLERY_HOME = [
  { key: "setup", src: "/images/stir/bar-tools.jpg", span: "wide" },
  { key: "cocktail", src: "/images/stir/cocktails-frame.jpg", span: "tall" },
  { key: "craft", src: "/images/stir/bartender.jpg", span: "std" },
  { key: "experience", src: "/images/stir/details-qr.jpg", span: "std" },
  { key: "details", src: "/images/stir/menu-napkins.jpg", span: "tall" },
];

export const GALLERY_ALL = [
  ...GALLERY_HOME,
  { key: "rooftop", src: "/images/stir/rooftop.jpg" },
  { key: "whitebar", src: "/images/stir/white-bar.jpg" },
  { key: "evening", src: "/images/stir/cocktails-evening.jpg" },
  { key: "inspiration", src: "/images/stir/sketch-vessel.jpg" },
];

export const CONTACT = {
  email: "hello@hudsonandstir.com",
  city: "New York City · Long Island · Select Tri-State",
};
